export class Option {
    constructor(display, value = null) {
        this._display = display;
        this._value = value;
        this._other_datas_to_set = [];
    }

    /**
     * @return Option
     * */
    otherDatasToSet(path, fields) {
        _.forEach(fields, (fieldValue, fieldName) => {
            this._other_datas_to_set.push({
                path: path,
                name: fieldName,
                value: fieldValue
            })
        })
        return this;
    }

}
